export default [
    "#ba1000",
    "#ba5f04",
    "#ba8f00",
    "#b4ba01",
    "#89ba04",
    "#26ba04"
]